import React from "react";
import Report from "../../../components/Report/Report";

const OtherReports = () => {
  return <Report type={"other"} />;
};

export default OtherReports;
